/**
 * Defines the bridge of the extending object.
 * 
 * The bridge has to be provided to the constructor.
 * 
 * The bridge is a function that returns the extending object.
 */
export class AllyBridge<Type> {
    protected bridge: () => Type & AllyBridge<Type>;

    /**
     * @param bridge The bridge to the extending object.
     */
    constructor(bridge: () => Type & AllyBridge<Type>) {
        this.bridge = bridge;
    }
}